<app-widget-base [title]="title | translate" [highlight]="highlight">
  <ng-container *ngIf="!comparisonData; else hasComparisonData">
    <div
      *ngFor="let elem of referenceData"
      class="elem"
      [class.highlight]="highlight.indexOf(elem.id) !== -1"
    >
      <p class="label">
        <span class="name">{{ elem.label || elem.category | translate }}</span>
        <span
          class="value top"
          *ngIf="!elem.disabled"
          [class.generic-tooltip]="isVisitsAvailable && stats"
          [attr.data-tooltip]="
            (getPercentageTotalValue(elem.value) | hideZeroValues : '1.0-1') +
            '% ' +
            ('over the total of' | translate) +
            ' ' +
            (keyIndicatorLabel | translate)
          "
        >
          {{
            elem.value && isNumber(elem.value) && unit !== '%'
              ? (elem.value | hideZeroValues : formatNumber)
              : formatPerc(elem.perc)
          }}
          <span>{{ unit }}</span>
        </span>
        <span
          *ngIf="elem.changed"
          class="changed"
          [class.up]="elem.changed > 0"
          [class.down]="elem.changed < 0"
        >
          <ng-container *ngIf="elem.changed > 0">+</ng-container>
          {{ elem.changed | number : '1.1-1' }}
          <span class="unit">%</span>
        </span>
      </p>
      <div class="popup" *ngIf="showTooltip">
        <h5>{{ elem.label || elem.category | translate }}</h5>
      </div>
      <div class="progressbar">
        <div
          [style.width]="(elem.value * 100) / maxValueCompareMode + '%'"
        ></div>
      </div>
    </div>
  </ng-container>
  <ng-template #hasComparisonData>
    <div
      *ngFor="let elem of referenceData; index as i"
      class="elem"
      [class.highlight]="highlight.indexOf(elem.id) !== -1"
    >
      <p class="label" [class.spaced]="!isCompact && i !== 0">
        <span [class.name]="isCompact" [class.compact]="isCompact">
          {{ elem.label || elem.category | translate }}
          <div *ngIf="isCompact">
            <span
              >{{
                elem.value && isNumber(elem.value) && unit !== '%'
                  ? (elem.value | hideZeroValues : '1.0-0')
                  : formatPerc(elem.perc)
              }}
              <span>{{ unit }}</span></span
            >
            &nbsp;·&nbsp;
            <span
              >{{
                comparisonData[i].value && isNumber(elem.value) && unit !== '%'
                  ? (comparisonData[i].value | hideZeroValues : '1.0-0')
                  : formatPerc(comparisonData[i].perc)
              }}
              <span>{{ unit }}</span></span
            >
          </div>
        </span>
        <span
          *ngIf="!isCompact"
          class="difference"
          [class.positive]="rawDifferences[i] > 0"
          [class.negative]="rawDifferences[i] < 0"
        >
          <span *ngIf="rawDifferences[i] > 0">+</span>
          <span>{{ differences[i] }}</span>
        </span>
      </p>
      <div class="progressbar tall">
        <div
          [style.width]="(elem.value * 100) / maxValueCompareMode + '%'"
        ></div>
        <span
          *ngIf="!isCompact"
          [class.right]="(elem.value * 100) / maxValueCompareMode > 60"
          class="label"
          >{{
            elem.value && isNumber(elem.value) && unit !== '%'
              ? (elem.value | hideZeroValues : '1.0-0')
              : formatPerc(elem.perc)
          }}
          <span>{{ unit }}</span></span
        >
      </div>
      <div class="progressbar tall">
        <div
          [style.width]="
            (comparisonData[i].value * 100) / maxValueCompareMode + '%'
          "
        ></div>
        <span
          *ngIf="!isCompact"
          [class.right]="
            (comparisonData[i].value * 100) / maxValueCompareMode > 60
          "
          class="label"
          >{{
            comparisonData[i].value && isNumber(elem.value) && unit !== '%'
              ? (comparisonData[i].value | hideZeroValues : '1.0-0')
              : formatPerc(comparisonData[i].perc)
          }}
          <span>{{ unit }}</span></span
        >
      </div>
    </div>
  </ng-template>
</app-widget-base>
